export const fieldMap: Record<string, string> = {
  title: "title",

  surname: "lastName",
  other_names: "firstName",
  email: "email",
  residential_address: "address",

  bank_account_number: "accountNumber",
  bank_account_name: "accountName",
  bank_name: "bankName",
  bank_sort_code: "bankCode",

  bank_verification_number: "bvn",

  nationality: "country",
  date_of_birth: "dateOfBirth",
  place_of_birth: "placeOfBirth",

  gender: "gender",
  lga: "lga",
  mobile: "mobile",

  marital_status: "relationshipStatus",
  state_of_origin: "state",

  occupation: "occupation",

  nok_email: "nok_email",
  nok_gender: "nok_gender",
  nok_mobile_number: "nok_mobile",
  nok_relationship: "nok_relationship",
  nok_contact_address: "nok_address",
  employer_address: "employmerAddress",
  annual_salary_income_range: "annualSalary",
  employer_name: "employmerName",
  employment_status: "employmentStatus",
  source_of_investment_fund: "sourceOfInvestmentFund",
  purpose_of_investment: "purposeOfInvestment",
  date_of_employment: "employmentDate",
  interest_reinvestment: "reinvest",
  fund_name: "productType",
};

export const transformData = (
  apiData: Record<string, any>,
  fieldMap: Record<string, string>,
) => {
  const result: Record<string, any> = {};

  Object.keys(apiData).forEach((apiKey) => {
    const formKey = fieldMap[apiKey] || apiKey;
    result[formKey] = apiData[apiKey] ?? "";
  });

  return result;
};
